import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {HelperService} from '../../helpers';
import {ActivatedRoute} from '@angular/router';
import {PostNumbers} from '../../constants';
import {Observable, of} from 'rxjs';
import {mergeMap} from 'rxjs/operators';

@Component({
  selector: 'app-contractor',
  templateUrl: './contractor.component.html',
  styleUrls: ['./contractor.component.scss']
})
export class ContractorComponent implements OnInit {

  public contractor: any = null;
  public postNumbers = Object.keys(PostNumbers.numbers).map((key, index) => {
    return {
      name: PostNumbers.numbers[key],
      number: key,
      search: key + ' ' + PostNumbers.numbers[key] + '' + key
    };
  });

  public postNumbersFilter: Observable<any>;
  public posteFilter: Observable<any>;

  public premiums: any = [];

  public form;
  public formSucces = false;
  public formError: string = null;
  public formProcessing = false;

  public loadingData = false;


  constructor(
    private http: HttpClient,
    private helper: HelperService,
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
        title: this.fb.control('', Validators.required),
        address: this.fb.control(''),
        postNumber: this.fb.control(null),
        poste: this.fb.control(null),
        website: this.fb.control(null, Validators.pattern(
          /(((http|https):\/{2})((?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/)),
        phoneNumbers: this.fb.array([]),
        emails: this.fb.array([]),
        premium: this.fb.control(null),
      }
    );

    this.postNumbersFilter = new Observable((observer: any) => {
      // Runs on every search
      observer.next(this.form.controls.postNumber.value);
    })
      .pipe(
        mergeMap((token: string): Observable<any> => {
          const query = new RegExp(token, 'i');

          return of(
            this.postNumbers.filter((poste: any) => {
              return query.test(poste.name) || query.test(poste.number);
            })
          );
        })
      );

    this.posteFilter = new Observable((observer: any) => {
      // Runs on every search
      observer.next(this.form.controls.poste.value);
    })
      .pipe(
        mergeMap((token: string): Observable<any> => {
          const query = new RegExp(token, 'i');

          return of(
            this.postNumbers.filter((poste: any) => {
              return query.test(poste.name) || query.test(poste.number);
            })
          );
        })
      );
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      if (params.contractor) {
        this.loadingData = true;

        this.http.get(
          this.helper.getApiUrl('/premium?premium_mainContractor=' + params.contractor)).subscribe(
          (premiums) => {
            this.premiums = premiums;
          });

        this.http.get(this.helper.getApiUrl('/zdravstvene-ustanove/' + params.contractor)).subscribe((contractor) => {
          this.contractor = contractor;
          this.form.controls.title.setValue(this.contractor.title.raw);
          this.form.controls.address.setValue(this.contractor.acf.contractor_address.contractor_address_address);
          this.form.controls.postNumber.setValue(this.contractor.acf.contractor_address.contractor_address_postNumber);
          this.form.controls.poste.setValue(this.contractor.acf.contractor_address.contractor_address_poste);
          this.form.controls.website.setValue(this.contractor.acf.contractor_website);
          this.form.controls.premium.setValue(this.contractor.acf.contractor_premiumAccount_relation.ID);

          const phoneNumbersForm = this.form.get('phoneNumbers') as FormArray;
          if (this.contractor.acf.contractor_phoneNumbers) {
            this.contractor.acf.contractor_phoneNumbers.forEach((phoneNumber) => {
              phoneNumbersForm.push(
                this.fb.group({
                  phoneNumber: phoneNumber.contractor_phoneNumbers_number
                })
              );
            });
          }

          const emailsForm = this.form.get('emails') as FormArray;
          if (this.contractor.acf.contractor_emails) {
            this.contractor.acf.contractor_emails.forEach((email) => {
              emailsForm.push(
                this.fb.group({
                  email: [email.contractor_emails_email, Validators.email]
                })
              );
            });
          }
          this.loadingData = false;
        });
      }
    });
  }

  addPhoneNumber() {
    const phoneNumbersForm = this.form.get('phoneNumbers') as FormArray;
    phoneNumbersForm.push(
      this.fb.group({
        phoneNumber: null
      })
    );
  }

  removePhoneNumber(index) {
    const phoneNumbersForm = this.form.get('phoneNumbers') as FormArray;
    phoneNumbersForm.removeAt(index);
  }

  addEmail() {
    const emailsForm = this.form.get('emails') as FormArray;
    emailsForm.push(
      this.fb.group({
        email: [null, Validators.email]
      })
    );
  }

  removeEmail(index) {
    const emailsForm = this.form.get('emails') as FormArray;
    emailsForm.removeAt(index);
  }

  onPostSelect(event) {
    this.form.controls.postNumber.setValue(event.item.number);
    this.form.controls.poste.setValue(event.item.name);
  }

  update(form) {

    this.formSucces = false;
    this.formError = null;
    if (!this.form.valid) {
      this.formError = 'Preverite vpisane podatke.';
      return;
    }

    this.formProcessing = true;

    const data = {
      title: this.form.controls.title.value,
      fields: {
        contractor_address: {
          contractor_address_address: this.form.controls.address.value,
          contractor_address_postNumber: this.form.controls.postNumber.value,
          contractor_address_poste: this.form.controls.poste.value,
        },
        contractor_phoneNumbers: [],
        contractor_emails: [],
        contractor_website: this.form.controls.website.value,
        contractor_premiumAccount_relation: this.form.controls.premium.value,
      },
    };

    const phoneNumbersForm = this.form.get('phoneNumbers') as FormArray;
    phoneNumbersForm.controls.forEach((control) => {
      data.fields.contractor_phoneNumbers.push({
        contractor_phoneNumbers_number: control.value.phoneNumber
      });
    });

    const emailsForm = this.form.get('emails') as FormArray;
    emailsForm.controls.forEach((control) => {
      data.fields.contractor_emails.push({
        contractor_emails_email: control.value.email
      });
    });


    this.http.put(this.helper.getApiUrl('/zdravstvene-ustanove/' + this.contractor.id), data).subscribe(
      (contractor) => {
        this.formProcessing = false;
        this.formSucces = true;
      }, (error) => {
        this.formProcessing = false;
        this.formError = 'Pri shranjevanju podatkov je prišlo do napake.';
      });
  }

}
